<app-page-bar></app-page-bar>

<app-page>

  <section *ngIf="partner">

    <mat-card class="app-card">
      <mat-card-header>
        <mat-card-title>{{partner.isNew() ? "New Partner" : partner.name}}</mat-card-title>
        <mat-card-subtitle *ngIf="!partner.isNew()">Created {{partner.created|date}}</mat-card-subtitle>
      </mat-card-header>
    </mat-card>

    <mat-card class="app-card">
      <mat-card-header>
        <mat-card-title>Information</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="form" id="partner-form" (ngSubmit)="savePartner()" novalidate>
          <div class="form-grid">
            <mat-form-field floatLabel="never">
              <input matInput placeholder="Name" formControlName="name" [readonly]="!editMode" appAutofocus />
            </mat-form-field>
          </div>
        </form>
      </mat-card-content>

      <mat-card-actions align="end">
        <button type="button" mat-button color="primary" *ngIf="!editMode" (click)="editPartner()">Edit</button>
        <button type="submit" mat-button color="primary" *ngIf="editMode" form="partner-form" [disabled]="!form.valid">Save</button>
        <button type="reset" mat-button *ngIf="editMode" (click)="revertPartner()">Cancel</button>
      </mat-card-actions>

    </mat-card>

  </section>

  <section *ngIf="sellers">

    <mat-card class="app-card">
      <mat-card-header>
        <mat-card-title>Sellers</mat-card-title>
      </mat-card-header>

      <mat-table [dataSource]="sellers" matSort (matSortChange)="sellers.setSort($event.active, $event.direction)"
        matSortDisableClear="true" [matSortActive]="sellers.state.sort.key"
        [matSortDirection]="sellers.state.sort.direction">

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.name}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="created">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Created</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.created | date}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon>arrow_forward</mat-icon>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="sellersColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: sellersColumns;" matRipple
          [routerLink]="['/settings/partners', row.parentPartnerId, 'sellers', row.partnerId]"></mat-row>

      </mat-table>

      <mat-paginator [length]="sellers.total" [pageIndex]="sellers.state.pager.page - 1"
        [pageSize]="sellers.state.pager.size" [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="sellers.setPage($event.pageIndex + 1, $event.pageSize)">
      </mat-paginator>
    </mat-card>
  </section>

  <div class="fab-bottom-right" *ngIf="partner?.partnerId">
    <a mat-fab [routerLink]="['/settings/partners', partner.partnerId, 'sellers', 'new']" color="primary" aria-label="Add a lead source">
      <mat-icon>add</mat-icon>
    </a>
  </div>

</app-page>
